<script>
import OwTable from '@/components/common/OwTable';
import TableRow from '@/components/cups/users/TableRow';

export default {
    name: 'CupsUsersTable',
    extends: OwTable,
    props: {
        headers: {
            type: Array,
            default: () => [
                'image', 'name',
            ],
        },
        tableRowComponent: {
            type: Object,
            default: () => TableRow,
        },
    },
};
</script>
